export default __webpack_public_path__ + "static/media/assemblySim1.7ee4ece4.jpg";